import { useState } from "react";
import { toast } from "sonner";
import { Copy, Check, ShieldCheck, ShieldAlert } from "lucide-react";

const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
};

export const Checksum = ({ f, isAdmin }) => {
  const [copied, setCopied] = useState(false);
  const [help, setHelp] = useState(false);
  if (!f.sha256) return null;
  const copy = async () => {
    if (!(await copyText(f.sha256))) return toast.error("Couldn't copy. Select the checksum and copy it yourself.");
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
    return undefined;
  };
  return (
    <span className="mt-2 block rounded-xl bg-[#F4F9FD] px-3 py-2" data-testid={`apps-file-sha-${f.id}`}>
      <span className="flex flex-wrap items-center gap-x-2 gap-y-1">
        <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-slate-500">SHA-256</span>
        {f.checksum_match === true && <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-semibold text-emerald-700" data-testid={`apps-file-sha-ok-${f.id}`}><ShieldCheck className="h-3 w-3" />Matches build job</span>}
        {isAdmin && f.checksum_match === false && <span className="inline-flex items-center gap-1 rounded-full bg-red-50 px-2 py-0.5 text-[11px] font-semibold text-red-700" data-testid={`apps-file-sha-mismatch-${f.id}`}><ShieldAlert className="h-3 w-3" />Doesn't match build job</span>}
        <button type="button" onClick={copy} className="ml-auto inline-flex items-center gap-1 text-xs font-medium text-sky-700 hover:text-sky-900" data-testid={`apps-file-sha-copy-${f.id}`}>
          {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}{copied ? "Copied" : "Copy"}
        </button>
      </span>
      <span className="mt-1 block break-all font-mono text-[11px] text-ink" data-testid={`apps-file-sha-value-${f.id}`}>{f.sha256}</span>
      {isAdmin && f.checksum_match === false && <span className="mt-1 block break-all font-mono text-[11px] text-red-700" data-testid={`apps-file-sha-expected-${f.id}`}>expected {f.expected_sha256}</span>}
      <button type="button" onClick={() => setHelp(!help)} className="mt-1 text-[11px] font-medium text-slate-600 hover:text-ink" data-testid={`apps-file-sha-help-${f.id}`}>{help ? "Hide" : "How do I check my download?"}</button>
      {help && (
        <span className="mt-1 block text-[11px] leading-relaxed text-slate-700">
          Windows: <code className="break-all">certutil -hashfile "{f.original_filename}" SHA256</code><br />
          Mac / Linux: <code className="break-all">shasum -a 256 "{f.original_filename}"</code><br />
          The result should match the code above exactly.
        </span>
      )}
    </span>
  );
};
